<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first" style="font-size:42px">Operational Emissions</span>
                    <span class="pdfPageTitle-txt__second" style="font-size:26px">({{PdftStore.fromData.spaceEmissionOperational?.weight}}% weight)</span>
                </div>
                <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page5.png">
                </div>
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">Emission data: </div>
                    <div class="txt">Scope1：<span class="mg_l">{{PdftStore.fromData.spaceEmissionOperational?.scope1Str}}</span></div>
                    <div class="txt">Scope2：<span class="mg_l">{{PdftStore.fromData.spaceEmissionOperational?.scope2Str}}</span></div>
                    <!-- <div class="tx">Data source: Pages xx, Report xx</div> -->
                </div>
                <div class="right">
                    <div class="title">Data and Reference Standard </div>
                    <div class="h4txt">{{PdftStore.fromData.spaceEmissionOperational?.referenceStandards}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">Detailed Scoring of the Carbon Neutral Operation Index</div>
                <List :type=1 :id="'listPdfReport1'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="top_box_banner">
                        <div class="title">Score for Operational Emissions </div>
                        <div class="jindu" v-if="PdftStore.fromData.spaceEmissionOperational">
                            <Progess :name="'page5progess'" :num="PdftStore.fromData.spaceEmissionOperational?.updateScore" :maxNum="'500 ten thousand'" :minNum="'3ten thousand'" :carbonNum="PdftStore.fromData.spaceEmissionOperational?.emissionDataStr" :max='100' :min='30'/>
                        </div>
                    </div>
                    <div class="title">Ranking of Enterprises Evaluated<span class="txt_s">（{{PdftStore.fromData.orgCount}}）</span></div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionOperational">
                        <EchartsList 
                        :xdata="PdftStore.fromData.spaceEmissionOperational.reportItemHistogram.xdata" 
                        :ydata="ydata" 
                        :series="PdftStore.fromData.spaceEmissionOperational.reportItemHistogram.series" 
                        :imgId="PdftStore.fromData.orgInfo.logoId" 
                        :name="'page5echartslist'"
                        />
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">Score and Scoring Criterion </div>
                        <div class="h4txt">{{PdftStore.fromData.spaceEmissionOperational?.scoreStandard}}</div>
                    </div>
                    <div class="title">Summary Performance of the Carbon Neutral Operation Index</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionOperational">
                        <Echarts :name="'page5echarts'" :type="'a'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">03</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import Progess from '../components/progess.vue'
import EchartsList from '../components/echartsList.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page5',
    components:{Headers, Bottoms, List, Progess, EchartsList, Echarts},
    setup() {
        const data = reactive({
            xdata:{
                name:'ten thousand',
                data:['0-10','11-50','51-100','101-200','201-300','301-400','>401']
            },
            ydata:{
                name:'',
                type:1
            },
            series:{
                data:[
                    {
                        value:60,
                        // type:1,
                        // name:'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId
                    }, 
                    16, 
                    28, 
                    25, 
                    8, 
                    3, 
                    2
                ],
            },
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            max-height: 200px;
            display: flex;
            .title{
                font-size: 28px;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 710px;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 53px;
                    .mg_l{
                        color: rgba(0, 186, 244, 1);
                    }
                }
                .tx{
                    margin-top: 15px;
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .right{
                width: calc(100% - 710px);
                padding-left: 40px;
                border-left: 1px solid #C5C5C6;
                .txt{
                    font-size: 20px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 42px;
                    margin-top: 23px;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    margin-top: 70px;
    .left_box{
        width: 670px;
        height: 100%;
        padding-right: 40px;
        border-right: 1px solid #C5C5C6;
    }
    .right_box{
        width: calc(100% - 670px);
        height: 100%;
        padding-left: 39px;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(350px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 40px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
        margin-top: 40px;
    }
    .txt_s{
        color: #999999;
    }
}
</style>